var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconApontaAtivo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 17,
    viewBox: "0 0 18 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.00195312,
    width: 18,
    height: 17,
    rx: 4,
    fill: "#5688C4"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.00195 2.75C9.69139 2.75 10.3741 2.8858 11.011 3.14963C11.648 3.41347 12.2268 3.80018 12.7143 4.28769C13.2018 4.7752 13.5885 5.35395 13.8523 5.99091C14.1162 6.62787 14.252 7.31056 14.252 8C14.252 8.68944 14.1162 9.37213 13.8523 10.0091C13.5885 10.646 13.2018 11.2248 12.7143 11.7123C12.2268 12.1998 11.648 12.5865 11.011 12.8504C10.3741 13.1142 9.69139 13.25 9.00195 13.25C7.60957 13.25 6.27421 12.6969 5.28964 11.7123C4.30508 10.7277 3.75195 9.39239 3.75195 8C3.75195 6.60761 4.30508 5.27226 5.28964 4.28769C6.27421 3.30312 7.60957 2.75 9.00195 2.75ZM8.5662 5.375C8.45017 5.375 8.33889 5.42109 8.25684 5.50314C8.1748 5.58519 8.1287 5.69647 8.1287 5.8125V8.4375C8.1287 8.55353 8.1748 8.66481 8.25684 8.74686C8.33889 8.82891 8.45017 8.875 8.5662 8.875H10.3145C10.4305 8.875 10.5418 8.82891 10.6238 8.74686C10.7059 8.66481 10.752 8.55353 10.752 8.4375C10.752 8.32147 10.7059 8.21019 10.6238 8.12814C10.5418 8.04609 10.4305 8 10.3145 8H9.0037V5.8125C9.0037 5.69647 8.95761 5.58519 8.87556 5.50314C8.79352 5.42109 8.68224 5.375 8.5662 5.375Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconApontaAtivo);
export default __webpack_public_path__ + "static/media/IconApontaAtivo.6373e256c76017882cfa2d751e5a56ac.svg";
export { ForwardRef as ReactComponent };